import { code } from "@spscommerce/utils";

export const SpsSummarylistViewExamples = {
    basic: {
        label: "Basic Usage",
        examples: {
            basic: {
                template: code`
                    <sps-summary-list-row *ngFor="let record of records">
                        <sps-summary-list-col width="2.875rem" lean>
                            <i aria-label="Favorite"
                                class="sps-icon sps-icon--md sps-icon-star lh-20 d-block mb-2 yellow300"
                            ></i>
                            <i aria-label="Flag" class="sps-icon sps-icon--md sps-icon-flag lh-20 d-block yellow300"></i>
                        </sps-summary-list-col>
                        <sps-summary-list-col>
                            <i aria-label="Error"
                                class="sps-icon sps-icon--lg sps-icon-status-error align-middle mr-2 pr-1"
                            ></i>
                            <div class="d-inline-block align-middle">
                                <div class="fs-18 lh-24"><a href="#">Heading</a></div>
                                <div class="fs-14 lh-20">Sub Heading</div>
                            </div>
                        </sps-summary-list-col>
                        <sps-summary-list-col width="13.13rem">
                            <sps-key-value-list inline>
                                <sps-key-value-list-item key="Title">
                                    Sub copy goes here
                                </sps-key-value-list-item>
                                <sps-key-value-list-item key="Long Title">
                                    Sub copy
                                </sps-key-value-list-item>
                                <sps-key-value-list-item key="Title">
                                    Sub copy goes here
                                </sps-key-value-list-item>
                            </sps-key-value-list>
                        </sps-summary-list-col>
                        <sps-summary-list-col width="8.75rem">
                            <sps-key-value-list>
                                <sps-key-value-list-item key="Buying From">
                                    75 Companies
                                    <div class="font-weight-light">38 of 75 Operational</div>
                                </sps-key-value-list-item>
                            </sps-key-value-list>
                        </sps-summary-list-col>
                        <sps-summary-list-col width="3.625rem" leaner>
                            <sps-dropdown>
                                <sps-dropdown-option>Option A</sps-dropdown-option>
                                <sps-dropdown-option>Option B</sps-dropdown-option>
                                <sps-dropdown-option>Option C</sps-dropdown-option>
                            </sps-dropdown>
                            <!-- <button type="button" class="sps-btn sps-btn--icon" aria-label="Actions">
                            <i class="sps-icon sps-icon-ellipses" aria-hidden="true" title="Open Actions Menu"></i>
                            </button> -->
                        </sps-summary-list-col>
                    </sps-summary-list-row>`,
                class: code`
                class DemoComponent {
                    records = [{}, {}, {}];
                  }`
            }
        }
    },
    expandable: {
        label: "Expandable",
        description: code`
            <p>If you put a <code>&lt;sps-summary-list-expansion&gt;&lt;/sps-summary-list-expansion&gt;</code>
            inside a Summary List Row, then it will be expandable to show the content in the expansion
            element. It can be toggled by clicking on it or by tabbing focus to it and hitting ENTER
            or SPACEBAR.</p>
        `,
        examples: {
            expandable: {
                template: code`
                    <sps-summary-list-row (expanded)="onExpand()" (collapsed)="onCollapse()" id="expandable">
                        <sps-summary-list-col width="">
                            <i aria-label="Error" class="sps-icon sps-icon--lg sps-icon-status-error align-middle mr-2 pr-1"></i>
                            <div class="d-inline-block align-middle">
                                <div class="fs-18 lh-24"><a href="#">Heading</a></div>
                                <div class="fs-14 lh-20">Sub Heading</div>
                            </div>
                        </sps-summary-list-col>
                        <sps-summary-list-col width="8.75rem">
                        <sps-key-value-list>
                            <sps-key-value-list-item key="Buying From">
                                75 Companies
                                <div class="font-weight-light">38 of 75 Operational</div>
                            </sps-key-value-list-item>
                        </sps-key-value-list>
                        </sps-summary-list-col>
                        <sps-summary-list-expansion>
                            <sps-card>
                                <sps-card-header title="Cap" icon="chart-pie"></sps-card-header>
                                    <sps-content-row *ngFor="let thing of things">
                                        <sps-content-row-col>
                                            <div class="sps-body-14">Heading/Title</div>
                                        </sps-content-row-col>
                                        <sps-content-row-col width="9.25rem">
                                            General Text Content
                                        </sps-content-row-col>
                                    </sps-content-row>
                            </sps-card>
                            <div class="text-center mt-3">
                                <button type="button" class="sps-btn sps-btn--link">Show More</button>
                            </div>
                        </sps-summary-list-expansion>
                    </sps-summary-list-row>`,
                class: code`
                class DemoComponent {
                    things = [{}, {}, {}, {}, {}];
                    onExpand(){
                        console.log("Expended");
                    }
                    onCollapse(){
                        console.log("Collapsed");
                    }
                }`
            }
        }
    },
    borderless: {
        label: "Removing Borders",
        description: code`
            <p>Placing the <code>borderless</code> attribute on a column will remove its left border.</p>
        `,
        examples: {
            borderless: {
                template: code`
                    <sps-summary-list-row>
                        <sps-summary-list-col>
                            <i aria-label="Error" class="sps-icon sps-icon--lg sps-icon-status-error align-middle mr-2 pr-1"></i>
                            <div class="d-inline-block align-middle">
                                <div class="fs-18 lh-24"><a href="#">Heading</a></div>
                                <div class="fs-14 lh-20">Sub Heading</div>
                            </div>
                        </sps-summary-list-col>
                        <sps-summary-list-col width="8.75rem" borderless>
                            <sps-key-value-list>
                                <sps-key-value-list-item key="Buying From">
                                75 Companies
                                <div class="font-weight-light">38 of 75 Operational</div>
                                </sps-key-value-list-item>
                            </sps-key-value-list>
                        </sps-summary-list-col>
                     </sps-summary-list-row>`
            }
        }
    },
    selectable: {
        label: "Selectable",
        description: code`
            <p>By placing a column with a checkbox and wiring that checkbox to control the
            <code>selected</code> input on the row, you can make rows selectable.</p>
        `,
        examples: {
            selectable: {
                template: code`
                    <sps-summary-list-row [selected]="exampleIsSelected">
                        <sps-summary-list-col width="2.875rem" lean>
                            <sps-checkbox aria-label="Row Selected" [(ngModel)]="exampleIsSelected"></sps-checkbox>
                        </sps-summary-list-col>
                        <sps-summary-list-col>
                            <i aria-label="Error" class="sps-icon sps-icon--lg sps-icon-status-error align-middle mr-2 pr-1"></i>
                            <div class="d-inline-block align-middle">
                            <div class="fs-18 lh-24"><a href="#">Heading</a></div>
                            <div class="fs-14 lh-20">Sub Heading</div>
                            </div>
                        </sps-summary-list-col>
                        <sps-summary-list-col width="8.75rem">
                            <sps-key-value-list>
                                <sps-key-value-list-item key="Buying From">
                                75 Companies
                                <div class="font-weight-light">38 of 75 Operational</div>
                                </sps-key-value-list-item>
                            </sps-key-value-list>
                        </sps-summary-list-col>
                        <sps-summary-list-expansion>
                            <sps-card><br/><br/><br/><br/><br/><br/></sps-card>
                            <div class="text-center mt-3">
                            <button type="button" class="sps-btn sps-btn--link">Show More</button>
                            </div>
                        </sps-summary-list-expansion>
                    </sps-summary-list-row>
                `,
                class: code`
                    class DemoComponent {
                        exampleIsSelected = true;
                    }
                `
            }
        }
    }
};
